module.exports = __webpack_public_path__ + "img/nc.5abc98ed.svg";